// extracted by mini-css-extract-plugin
export default {"onlyDark":"CVContentList_onlyDark__IBNVr","onlyLight":"CVContentList_onlyLight__ohR9l","cv-content-list":"CVContentList_cv-content-list__qCtUg"};